/**
 * @generated SignedSource<<dee6dfd5b42b021df80dadca7c70e2cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sourcesPage_DisconnectMutation$variables = Record<PropertyKey, never>;
export type sourcesPage_DisconnectMutation$data = {
  readonly qboConnectionDisconnect: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly ok: boolean;
  } | null | undefined;
};
export type sourcesPage_DisconnectMutation = {
  response: sourcesPage_DisconnectMutation$data;
  variables: sourcesPage_DisconnectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ok",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "sourcesPage_DisconnectMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QboConnectionDisconnectMutationPayload",
        "kind": "LinkedField",
        "name": "qboConnectionDisconnect",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "sourcesPage_DisconnectMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QboConnectionDisconnectMutationPayload",
        "kind": "LinkedField",
        "name": "qboConnectionDisconnect",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c410b886c9f2c26110c7c3394fdaeb53",
    "id": null,
    "metadata": {},
    "name": "sourcesPage_DisconnectMutation",
    "operationKind": "mutation",
    "text": "mutation sourcesPage_DisconnectMutation {\n  qboConnectionDisconnect {\n    ok\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a08fac43666a2814c3c6d673632b17b";

export default node;
